import projects from "./projects";

export const apiProjects = projects;
